import { useField } from 'formik'
import React from 'react'

import TextArea from '@/components/TextArea'

type Props = {
  handleTracking?: () => void
  id?: string
  label: string
  name: string
  placeholder?: string
  required?: boolean
}

export const FormikTextarea: React.FC<Props> = (props) => {
  const [field, meta, helpers] = useField(props)
  const { onBlur, value } = field
  const { setValue } = helpers
  const { error, touched } = meta

  return (
    <TextArea
      error={touched && error}
      label={props.label}
      name={props.name}
      placeholder={props.placeholder}
      /**
       * FIXME investigate why Formik's onChange does not work here
       */
      required={props.required}
      value={value}
      onBlur={(e: React.FocusEvent<HTMLTextAreaElement>) => {
        onBlur(e)
        typeof props.handleTracking === 'function' && props.handleTracking()
      }}
      onChange={setValue}
    />
  )
}
